module.exports = __webpack_public_path__ + "fonts/iconfont.2b7a0d55.woff";